import SendCheckViewContent from './SendCheckViewContent';
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
  trxAddress: string;
  sendAddress: string;
  curculateKrw: string;
  sendAsset: string;
  selectedAsset?: ViewModel.IAsset;
  trxBalance: string;
  fee?: number;
  isFeeNotice: boolean;
  isCancelModalOpen: boolean;
  isSendCompleteModalOpen: boolean;
  isFeeNoticeModalOpen: boolean;
  onClickBacktoSendView: () => void;
  onClickSendCheckNextBtn: () => void;
  onClickSendCancelBtn: () => void;
  onClickCancelModalClose: () => void;
  onClickCancelModalYes: () => void;
  onClickSendCompleteModalConfirm: () => void;
  onClickFeeNoticeModalClose: () => void;
}

const SendCheckView = ({
  trxAddress,
  sendAddress,
  curculateKrw,
  sendAsset,
  selectedAsset,
  trxBalance,
  fee,
  isFeeNotice,
  isCancelModalOpen,
  isSendCompleteModalOpen,
  isFeeNoticeModalOpen,
  onClickSendCheckNextBtn,
  onClickSendCancelBtn,
  onClickCancelModalClose,
  onClickCancelModalYes,
  onClickSendCompleteModalConfirm,
  onClickFeeNoticeModalClose,
}: IProps) => {
  return (
    <div className="send-content send-container send-confirm-container">
      <SendCheckViewContent
        trxAddress={trxAddress}
        sendAddress={sendAddress}
        curculateKrw={curculateKrw}
        sendAsset={sendAsset}
        selectedAsset={selectedAsset}
        trxBalance={trxBalance}
        fee={fee}
        isFeeNotice={isFeeNotice}
        isCancelModalOpen={isCancelModalOpen}
        isSendCompleteModalOpen={isSendCompleteModalOpen}
        isFeeNoticeModalOpen={isFeeNoticeModalOpen}
        onClickSendCheckNextBtn={onClickSendCheckNextBtn}
        onClickSendCancelBtn={onClickSendCancelBtn}
        onClickCancelModalClose={onClickCancelModalClose}
        onClickCancelModalYes={onClickCancelModalYes}
        onClickSendCompleteModalConfirm={onClickSendCompleteModalConfirm}
        onClickFeeNoticeModalClose={onClickFeeNoticeModalClose}
      />
    </div>
  );
};

export default SendCheckView;
